module.exports = __webpack_public_path__ + "img/ru.ee6e988a.jpg";